import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildMarginStabilityChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  extractAnalysisPeriod,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelMarginStability = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Margin Stability";
  const lines = stripTitleLines(cleanLines(markdown));
  const analysisPeriod = extractAnalysisPeriod(lines);
  const filteredLines = lines.filter((line) => !/^analysis period/i.test(line));
  const { table, before, after } = extractTableBlock(filteredLines);
  const chart = buildMarginStabilityChart(table);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  return (
    <FunnelInsightCard
      title={title}
      kicker="Risk Diagnostics"
      sections={[
        {
          title: "Margin Risk Metrics",
          chart,
          chartTitle: "Margin Stability Radar",
          chartSubtitle:
            "Radar works nicely here because this report is about shape, balance, and weak spots.",
          table,
          meta: analysisPeriod ? `Analysis Period: ${analysisPeriod}` : null,
          paragraphs: before.length ? toParagraphs(before) : [],
        },
        {
          title: "What Does This Mean?",
          bullets,
          paragraphs,
          verdict,
        },
      ]}
    />
  );
};

export default FunnelMarginStability;
